export const visit = (vm, at) => {
at({ "en": { "conversations-thread-view": { "publish-message": { "closeThreadError": { "title": "Something went wrong", "message": "There was a problem sending your message and closing the conversation. Please try again." } } } } });
};